import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Subject, tap } from "rxjs";
import { UserInfo } from "../model/user";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class UserServiceApi {

    userBehaviorSubject = new BehaviorSubject<UserInfo>({});
    currentUser: Subject<UserInfo> = new Subject()

    constructor(private http: HttpClient, private router: Router) {
    }

    getUserById() {
        
        return this.http.get(environment.userManagementUrl.userInfos).pipe(
            tap((response: any) => {
                this.userBehaviorSubject.next(response?.data)
                this.currentUser.next(response?.data)
            })
        )
    }

    updateUser(id: string, {name, email, profilePicture}: {name: string, email: string, profilePicture: string}) {
        return this.http.put(environment.userManagementUrl.updateNameEmail.replace('{id}', id), {name, email, profilePicture}).pipe(
            tap((response: any) => {
                this.userBehaviorSubject.next(response?.data)
            })
        )
    }

    updatePassword({currentPassword, newPassword}: {currentPassword: string, newPassword: string}) {
        return this.http.put(environment.userManagementUrl.updatePassword, {currentPassword, newPassword}).pipe(
            tap((response: any) => {
                this.userBehaviorSubject.next(response?.data)
            })
        )
    }

}
